import type { Theme } from '@avs/contract';
import { useApp } from '../state/AppContext.js';
import { Icon } from '../icons/Icon.js';

const THEMES: Array<{ key: Theme; icon: 'monitor' | 'sun' | 'moon'; title: string }> = [
  { key: 'system', icon: 'monitor', title: '跟随系统' },
  { key: 'light',  icon: 'sun',     title: '亮色' },
  { key: 'dark',   icon: 'moon',    title: '暗色' },
];

export function SidebarFooter() {
  const { state, actions } = useApp();
  return (
    <div className="sidebar-footer">
      {THEMES.map((t) => (
        <button
          key={t.key}
          type="button"
          className={'theme-btn' + (state.theme === t.key ? ' active' : '')}
          onClick={() => actions.setTheme(t.key)}
          title={t.title}
        >
          <Icon name={t.icon} size={16} />
        </button>
      ))}
      <button
        type="button"
        className="theme-btn footer-collapse"
        onClick={actions.toggleCollapsed}
        title={state.collapsed ? '展开侧栏' : '收起侧栏'}
      >
        <Icon name="collapse" size={16} />
      </button>
    </div>
  );
}
